import React from 'react';

const OCCExceptionTabComponentLoadable = React.lazy(() => import('./ExceptionTab'));

export {
    OCCExceptionTabComponentLoadable
}